import { createSlice } from "@reduxjs/toolkit";

const initialState: { token?: string } = {
  token: undefined,
};

const oldSiteSlice = createSlice({
  name: "oldSite",
  initialState,
  reducers: {
    oldSiteLoggedIn: (state, action) => {
      state.token = action.payload;
    },
    userLoggedOut: (state) => {
      state.token = undefined;
    },
  },
});

export const { userLoggedOut } = oldSiteSlice.actions;
export default oldSiteSlice.reducer;
